import { SpeakButton } from '@web/lib/audio'
import type { ExerciseRendererProps } from './types'

export function TranslationExercise({
  content,
  response,
  onChange,
  locked,
}: ExerciseRendererProps<'translation'>) {
  const toPortuguese = content.direction === 'en_pt'

  return (
    <div className="space-y-4">
      <blockquote className="flex items-center gap-3 rounded-xl bg-sand-100 px-4 py-3">
        <p className="flex-1 text-lg text-ink-900" lang={toPortuguese ? 'en' : 'pt-BR'}>
          {content.source}
        </p>
        {/* Only when the prompt itself is Portuguese. For en→pt the Portuguese
            is the answer, and it gets a speaker in the feedback instead. */}
        {!toPortuguese && <SpeakButton text={content.source} />}
      </blockquote>

      <div>
        <label htmlFor="translation" className="mb-1.5 block text-sm font-medium text-ink-700">
          {toPortuguese ? 'Write it in Portuguese' : 'Write it in English'}
        </label>
        <textarea
          id="translation"
          rows={2}
          value={response?.text ?? ''}
          onChange={(e) => onChange({ type: 'translation', text: e.target.value })}
          disabled={locked}
          lang={toPortuguese ? 'pt-BR' : 'en'}
          autoCapitalize="sentences"
          autoCorrect="off"
          // Autocorrect off matters: iOS will happily "fix" Portuguese into
          // English words while she types.
          spellCheck={false}
          className="w-full resize-none rounded-xl bg-white px-4 py-3 text-base ring-1 ring-sand-200 focus:ring-2 focus:ring-brand-600 disabled:bg-sand-50"
        />
      </div>
    </div>
  )
}
